/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Error_Create_Set_LogInputs */

const en_tags_manager_error_create_set_log = /** @type {(inputs: Tags_Manager_Error_Create_Set_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error writing new set:`)
};

const fr_tags_manager_error_create_set_log = /** @type {(inputs: Tags_Manager_Error_Create_Set_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors de la creation de l'ensemble :`)
};

const de_tags_manager_error_create_set_log = /** @type {(inputs: Tags_Manager_Error_Create_Set_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Schreiben des neuen Sets:`)
};

const it_tags_manager_error_create_set_log = /** @type {(inputs: Tags_Manager_Error_Create_Set_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore durante la scrittura del nuovo set:`)
};

const ru_tags_manager_error_create_set_log = /** @type {(inputs: Tags_Manager_Error_Create_Set_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка при записи нового набора данных:`)
};

const es_tags_manager_error_create_set_log = /** @type {(inputs: Tags_Manager_Error_Create_Set_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al escribir el nuevo conjunto:`)
};

const zh_cn2_tags_manager_error_create_set_log = /** @type {(inputs: Tags_Manager_Error_Create_Set_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`写入新数据集时出错：`)
};

const ja_tags_manager_error_create_set_log = /** @type {(inputs: Tags_Manager_Error_Create_Set_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいセットの書き込み中にエラーが発生しました:`)
};

const hi_tags_manager_error_create_set_log = /** @type {(inputs: Tags_Manager_Error_Create_Set_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया सेट लिखने में त्रुटि:`)
};

const pt_pt2_tags_manager_error_create_set_log = /** @type {(inputs: Tags_Manager_Error_Create_Set_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro ao escrever novo conjunto:`)
};

/**
* | output |
* | --- |
* | "Error writing new set:" |
*
* @param {Tags_Manager_Error_Create_Set_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_error_create_set_log = /** @type {((inputs?: Tags_Manager_Error_Create_Set_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Error_Create_Set_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_error_create_set_log(inputs)
	if (locale === "de") return de_tags_manager_error_create_set_log(inputs)
	if (locale === "it") return it_tags_manager_error_create_set_log(inputs)
	if (locale === "ru") return ru_tags_manager_error_create_set_log(inputs)
	if (locale === "es") return es_tags_manager_error_create_set_log(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_error_create_set_log(inputs)
	if (locale === "ja") return ja_tags_manager_error_create_set_log(inputs)
	if (locale === "hi") return hi_tags_manager_error_create_set_log(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_error_create_set_log(inputs)
	return en_tags_manager_error_create_set_log(inputs)
});